import React from "react";
import {
  Box,
  IconButton,
  Tooltip,
  Badge,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import { Message as MessageIcon } from "@mui/icons-material";
import NewColors from "../../../../../themes/NewColors";

import { ClientMessages } from "../../clients/ClientSummaryComponentModules";

const ReportsFloatingActions = ({ messageGroup, client }) => {
  const [messagesOpen, setMessagesOpen] = React.useState(false);

  // Note: Removed body scroll locking to allow background scrolling
  // and preserve scroll position when chat modal opens/closes

  return (
    <>
      {/* Floating Action Buttons */}
      <Box
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Tooltip title="Open Messages">
          <IconButton
            color="primary"
            size="large"
            sx={{
              bgcolor: "primary.main",
              color: "white",
              "&:hover": { bgcolor: "primary.dark" },
            }}
            onClick={() => setMessagesOpen(!messagesOpen)}
          >
            <Badge badgeContent={0} color="error">
              <MessageIcon />
            </Badge>
          </IconButton>
        </Tooltip>
      </Box>

      {/* Messages Panel */}
      {messagesOpen && (
        <Box
          sx={{
            position: "fixed",
            bottom: 100,
            right: 20,
            width: 500,
            height: 650,
            zIndex: 1000,
            boxShadow: 3,
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <Card
            sx={{
              height: "100%",
              display: "flex",
              flexDirection: "column",
              backgroundColor: NewColors.cardBackground,
            }}
          >
            <CardHeader
              sx={{
                borderBottom: 1,
                borderColor: "divider",
                py: 1,
                backgroundColor: "primary.main",
                color: "white",
              }}
              title="Messages"
              action={
                <IconButton
                  onClick={() => setMessagesOpen(false)}
                  sx={{ color: "white" }}
                >
                  ×
                </IconButton>
              }
            />
            <CardContent
              sx={{
                flex: 1,
                p: 0,
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <ClientMessages uid={client?.uid} groupId={messageGroup?.id} clientAvatarUrl={client?.avatarUrl} />
            </CardContent>
          </Card>
        </Box>
      )}

      {/* Semi-transparent overlay for visual separation (non-blocking) */}
      {messagesOpen && (
        <Box
          onClick={() => {
            if (messagesOpen) setMessagesOpen(false);
          }}
          sx={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: "rgba(0,0,0,0.2)", // Reduced opacity for less intrusion
            zIndex: 999, // Just below the dialog
            cursor: "pointer",
            pointerEvents: "auto", // Allow clicking to close but don't block scroll
          }}
        />
      )}
    </>
  );
};

export default ReportsFloatingActions;
